import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * хэлперы для хранения/восстановления данных о просмотренности стори в sessionStorage
 * пока пусть будут здесь, в дальнейшем, возможно, надо будет вытащить эту логику наружу
 */

var SESSION_STORAGE_KEY = 'viewedStories';

/**
 * @desc: пометить стори как просмотренную
 */
var setStoryViewed = function setStoryViewed(id) {
  var viewedStories = sessionStorage.getItem(SESSION_STORAGE_KEY);
  try {
    var updatedStories = viewedStories ? _objectSpread(_objectSpread({}, JSON.parse(viewedStories)), {}, _defineProperty({}, id, true)) : _defineProperty({}, id, true);
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(updatedStories));
  } catch (e) {
    console.error(e);
  }
};

/**
 * @desc: получить список просмотренных стори
 */
var getViewedStories = function getViewedStories() {
  var viewedStories = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (!viewedStories) {
    return null;
  }
  try {
    return JSON.parse(viewedStories);
  } catch (e) {
    console.error(e);
    return null;
  }
};
var getDetailItems = function getDetailItems(list) {
  return list.reduce(function (items, _ref2) {
    var slides = _ref2.slides;
    if (!Array.isArray(slides)) {
      items.push(slides);
    }
    return items;
  }, []);
};
var isSwiperContainer = function isSwiperContainer(target) {
  return target.classList.contains('swiper-container');
};
export { getDetailItems, getViewedStories, isSwiperContainer, setStoryViewed };